import styled from "styled-components";
import bubblebg from "../images/bubblebannerbg.png";
import thumbnail from "../images/thumbnail-video.png"




const HowIWorkContainerStyled = styled.div`
    
    
`;

const HowIWorkBannerStyled = styled.div`
    background:
            linear-gradient(to right, rgba(12, 30, 40, 0.5), rgba(12, 30, 40, 0.5)),
            url(${bubblebg});
    background-size: cover;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    color: #fff;
    justify-content: center;
    align-items: center;
    text-align: center;
    p{
        font-weight: 300;
    }
    .buttonContainer{
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 50%;
        align-items: center;
        gap: 0.6rem;
        @media only screen and (min-width: 992px) {
            flex-direction: row;
        }
    }
    @media only screen and (min-width: 992px) {
        padding: 2rem;
        h1{
            font-size: 3rem;
        }
        p{
            width: 50%;
            font-size: 1.2rem;
        }
    }
`;

const HowIWorkSectionStyled = styled.section.withConfig({
    shouldForwardProp: (prop) => !['orientation', 'video'].includes(prop)
})`
    display: flex;  
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    .switcher{
        display: flex;
        flex-direction: ${({orientation})=> orientation ? 'column-reverse' : 'column'};
        gap: 2rem;
        .card {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            @media only screen and (min-width: 600px) {
                flex-direction: row;
                flex-wrap: wrap;
            }
        }
        .video{
            position: relative;
            width: 100%;
            border: 1px solid #5fbec5;
            background:
                    linear-gradient(to right, rgba(12, 30, 40, 0.5), rgba(12, 30, 40, 0.5)),
                    url(${thumbnail}) center center;
            background-size: cover;
            height: 210px;
            border-radius: 10px;
            cursor: pointer;
            object-fit: cover;
            @media only screen and (min-width: 992px) {
                height: 370px;
                width: 50%;
                margin: 0 auto;

            }
            iframe {
                display: ${({video})=> video === "true" ? 'block' : 'none'};
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border: 0;
            }
            .contentOverlay{
                position: absolute;
                display: ${({video})=> video === "true" ? 'none' : 'flex'};
                flex-direction: column;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                
                gap: 1rem;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
            }
        }
        
    }
    
    
`

const ProcessCardStyled = styled.div`
    flex: 1 1 100%; 
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    width: 100%;
    margin-bottom: 2rem;
    background: ${({theme})=> theme === 'dark' ? '#0C1E28' : '#fff'};
    border-radius: 20px;
    box-shadow: ${({ theme }) => theme === 'dark' ? '0px 4px 8px 0px rgba(111, 203, 209, 0.25)' : '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'};
    transition: border 0.3s ease-out;
    &:hover{
        border: 0.03rem solid #5fbec5;
       
    }
    @media only screen and (min-width: 600px) {
        flex: 1 1 calc(50% - 1rem); 
        width: calc(50% - 1rem);
    }

    @media only screen and (min-width: 900px) {
        flex: 1 1 calc(28% - 1rem); 
        width: calc(28% - 1rem);
    }
    
    h3{
        background: #5fbec5;
        width: 95%;
        margin: 0.5rem auto;
        color: #fff;
        border-top-left-radius: 1.25rem;
        border-top-right-radius: 1.25rem;
        text-align: center;
        padding: 1rem;
    }
    span{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 1rem auto;
    }
    p{
        width: 95%;
        text-align: center;
        font-size: .9rem;
        margin-bottom: 2rem;
    }

`


export { HowIWorkContainerStyled, HowIWorkBannerStyled, HowIWorkSectionStyled, ProcessCardStyled  };